import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Squash as Hamburger } from 'hamburger-react';
import '../css/Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <nav className="navbar" id="navbar">
        <div className="nav-container">
          <div className="logo">BlocBox</div>
          <div className="hamburger">
            <Hamburger 
              toggled={isMenuOpen} 
              toggle={setIsMenuOpen} 
              color="var(--primary-cyan)"
              size={24}
            />
          </div>
          <ul className="nav-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/aboutus">FAQ</Link></li>
            <li><Link to="/contactus">Contact us</Link></li>
          </ul>
          <div className="mobile-menu" style={{ display: isMenuOpen ? 'flex' : 'none' }}>
            <Link to="/">Home</Link>
            <Link to="/contactus">Contact us</Link>
            <Link to="/aboutus">FAQ</Link>
            <Link to="/aboutus">Download APP</Link>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;